export const GET_ALL_AUCTIONS = 'GET_ALL_AUCTIONS'
export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
export const GET_SINGLE_AUCTION = 'GET_SINGLE_AUCTION'
export const GET_AUCTION_PROJECTS = 'GET_AUCTION_PROJECTS'
